import { useEffect, useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "../SAConfigs";

export const useNumberFormatter = ({
  field,
  formatPhone = false,
  slice = 0,
  form,
  callback,
}: {
  field: string;
  formatPhone?: boolean;
  slice?: number;
  form: any;
  callback?: (formattedValue: string) => any;
}) => {
  const { getValues, watch, setValue } = form;
  useEffect(() => {
    const number = getValues(field);
    const updatedNumber = formatNumber(number, {
      formatPhone: formatPhone,
      slice: slice,
    });
    setValue(field, updatedNumber);
    if (callback && updatedNumber.length == 5) {
      try {
        callback(updatedNumber);
      } catch (error) {
        console.error("Error handling the promise:", error);
      }
    }
  }, [watch(field)]);
};

export const formatNumber = (
  value: string,
  phoneObj: { formatPhone: boolean; slice: number },
) => {
  if (!value) return value;
  const number = value.replace(/[^\d]/g, "");
  const numberLength = number.length;
  if (phoneObj.formatPhone) {
    if (numberLength < 4) return number;
    if (numberLength < 7) {
      return `(${number.slice(0, 3)}) ${number.slice(3)}`;
    }
    return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(
      6,
      10,
    )}`;
  } else {
    return `${number.slice(0, phoneObj.slice)}`;
  }
};
